import clsx from "clsx"
import { HTMLAttributes, memo } from "react"

import { MainHeader } from "@/components/Header"

import cls from "./AppLayout.module.scss"

export const AppLayout = memo(({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <MainHeader />
      {children}
    </>
  )
})

type MainProps = {
  page?: boolean
  pageContrast?: boolean
  overflowHidden?: "all" | "md" | "sm"
  wrapperClassName?: string
} & HTMLAttributes<HTMLDivElement>

export const Main = memo(({ page, pageContrast, overflowHidden, wrapperClassName, className, children }: MainProps) => {
  return (
    <main className={clsx(cls.main, overflowHidden && cls[`overflowHidden-${overflowHidden}`], className)}>
      <div className={clsx(cls.content, page && cls.page, pageContrast && cls.contrast, wrapperClassName)}>
        {children}
      </div>
    </main>
  )
})
